import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './ThemesListItem.css';


const ThemesListItem = ({ me, onClick, active, theme }) => {
  const calculateClassName = () => {
    let value = 'themes-list-item__component';
    if (active) { value += ' active'; }
    return value;
  };
  const { t } = useTranslation();

  return (
    <div
      className={calculateClassName()}
      onClick={onClick}
      role="button"
      tabIndex={-1}
    >
      <div className={`checked-icon${active ? ' active' : ''}`} />
      <ProFeaturePlaceholder
        placeholderContent={
          <div>
            {t("This theme is available on the PRO plan.")}
          </div>
        }
        key={`theme-item-theme-pro-feature-key-${theme.id}`}
        proLabel={theme.is_pro}
        locked={
          me &&
          me.subscription &&
          !me.subscription.ff_background_image &&
          theme.is_pro
        }
        className={`wrapper ${theme.theme_class}`}
      />
      <div
        className={`theme-name${active ? ' active' : ''}`}
      >
        {theme.name}
      </div>
    </div>
  );
};

ThemesListItem.propTypes = {
  me: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  theme: PropTypes.object,
};

ThemesListItem.defaultProps = {
  me: null,
  active: null,
};


export default ThemesListItem;
